// src/components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            alert('Your message has been sent successfully!');
            setFormData({ name: '', email: '', phone: '', message: '' });
        } catch (error) {
            alert('There was a problem sending your message.');
        }
    };

    return (
        <div className="contact-page">
            <header className="contact-header">
                <h1>Contact Us</h1>
                <p>Get in touch with us for any inquiries or support.</p>
            </header>
            <div className="contact-content">
                <div className="contact-form-container">
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="phone"
                            placeholder="Your Phone (optional)"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                        <textarea
                            name="message"
                            rows="6"
                            placeholder="Your Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                        <button type="submit">Submit</button>
                    </form>
                </div>
                <div className="contact-info">
                    <h2>Contact Information</h2>
                    <div>
                        <h3>Corporate Office & Factory</h3>
                        <p>Plot No- C-89 , Sector-63</p>
                        <p>Noida-201301</p>
                        <p>UP, India</p>
                    </div>
                    
                    <div>
                        <h3>Email Address</h3>
                        <p>sanjeev.saini@jaikon.com</p>
                         <p>sanjeev.saini@jaikon.com</p>
                    </div>
                    <div>
                        <h3>Marketing & Sales</h3>
                        <h3>Email Address</h3>
                        <p>sales@jaikon.com</p>
                        <p>+91  9871456631</p>
                        <p>0120 – 4166376</p>
                    </div>
                    <div>
                        <h3>Service Desk</h3>
                        <p>0120 – 4166376</p>
                    </div>
                    <div className="map-container">
                      <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.4002721720517!2d77.3810729751423!3d28.61776327567274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ceff4bcc429b5%3A0x8ae6ed47e1e9421b!2sJaikon%20Refrigeration%20India%20Private%20Limited!5e0!3m2!1sen!2sin!4v1723799895756!5m2!1sen!2sin" 
          width="600" 
        height="450" 
        style={{ border: '0' }} 
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
    ></iframe>
</div>

                </div>
            </div>
        </div>
    );
};

export default Contact;
